import React, { useEffect, useMemo, useState } from "react"
import ClientHeader from "~components/ClientInfo/ClientHeader"
import FunnelFilter from "./FunnelFilter/FunnelFilter"
import FunnelTabs from "./FunnelTabs/FunnelTabs";

import './style.scss';
import prepareForOptions from "~services/utils/prepareForOptions";

const FunnelLayout = ({ workFinished, cliente, children, filter, tabs, canShutWork, hideSearch, handleShutWork, orderFilter, setOrderFilter, className, definedFilter, hideFilters, hideSelectFilters, filters, setFilters }) => {
  const [groupProductFilter, setGroupProductFilter] = useState({});
  const [productFilter, setProductFilter] = useState({});
  const [negotiationFilter, setNegotiationFilter] = useState({});
  const [objects, setObjects] = useState({
    grupos: {},
    produtos: {}
  });

  const filterProps = {
    order: orderFilter,
    setOrder: setOrderFilter,
    productGroup: groupProductFilter,
    setProductGroup: setGroupProductFilter,
    product: productFilter,
    setProduct: setProductFilter,
    negotiation: negotiationFilter,
    setNegotiation: setNegotiationFilter,
    hideFilters,
    cliente,
    handleShutWork,
    canShutWork,
    workFinished,
    hideSelectFilters
  }

  const productsFilter = useMemo(() => {
    if (!objects?.produtos || !objects?.grupos || typeof definedFilter !== "object" || Object.entries(definedFilter)?.length === 0) {
      return [];
    }
  
    const temp = Object.entries(definedFilter).reduce((acc, [key, value]) => {
      const grupo = objects.grupos[`id-${key}`];
      if (!grupo) return acc;
  
      acc[key] = {
        label: grupo.nome,
        value: grupo.id,
        skus: [],
      };
  
      if (Array.isArray(value.options) && value.options.length > 0) {
        acc[key].skus = prepareForOptions(value.options
          .map((e) => objects.produtos[`id-${e}`])
          .filter(Boolean), 'nome','id');
      }
  
      return acc;
    }, {});

    return Object.values(temp);
  }, [objects?.produtos, objects?.grupos, definedFilter]);
  
  return (
    <main className={`funnel-layout ${className}`}>
      <ClientHeader dados={cliente} />

      {tabs && (
        <FunnelTabs tabs={tabs} hideSearch={hideSearch} />
      )}

      {filter && (
        <FunnelFilter props={filterProps} filters={filters} setFilters={setFilters} productsFilter={productsFilter} setObjects={setObjects} objects={objects} />
      )}

      {children}
    </main>
  )
}

export default FunnelLayout;